import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Download, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const bookingId = sp.get("booking_id");
  const orderId = sp.get("order_id");
  const txn = sp.get("txn");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (bookingId) api.get(`/bookings/${bookingId}`).then(r => setData(r.data));
  }, [bookingId]);

  return (
    <div>
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <div className="w-20 h-20 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto animate-bounce">
          <CheckCircle2 size={44}/>
        </div>
        <h1 className="font-heading text-3xl font-bold mt-6">Payment Successful</h1>
        <p className="text-slate-600 mt-2">Thanks! Your {bookingId ? "booking" : "order"} is confirmed.</p>

        <div className="mt-8 bg-white rounded-3xl card-shadow p-6 text-left">
          {data && (
            <>
              <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Booking ID</span><span className="font-mono">{data.booking_id}</span></div>
              <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Token</span><span className="font-semibold">{data.token_number}</span></div>
              <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Service</span><span className="uppercase">{data.service_type}</span></div>
              <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Slot</span><span>{data.slot_date} · {data.slot_time}</span></div>
              <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Patient</span><span>{data.patient?.name}</span></div>
              <div className="flex justify-between py-2 font-semibold text-lg"><span>Total Paid</span><span>₹{data.total_amount}</span></div>
            </>
          )}
          {orderId && <div className="flex justify-between py-2 border-b"><span className="text-slate-500">Order</span><span className="font-mono">{orderId}</span></div>}
          {txn && <div className="flex justify-between py-2"><span className="text-slate-500">Transaction</span><span className="font-mono text-sm">{txn}</span></div>}
        </div>

        <div className="flex justify-center gap-3 mt-6">
          <Link to="/dashboard" className="btn-primary">Go to Dashboard <ArrowRight size={16}/></Link>
          <Link to="/" className="btn-outline">Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export function PaymentFailed() {
  return (
    <div>
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <div className="w-20 h-20 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto text-4xl">✕</div>
        <h1 className="font-heading text-3xl font-bold mt-6">Payment Failed</h1>
        <p className="text-slate-600 mt-2">Something went wrong. Please try again.</p>
        <div className="flex justify-center gap-3 mt-6">
          <Link to="/" className="btn-primary">Home</Link>
          <Link to="/dashboard" className="btn-outline">Dashboard</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
